import { useMemo } from "react";
import { useAppSelector } from "../../globalState/hooks";
import { LoginRootState } from "../../types/login";

export const AccessRoleMasterModule = (functionalityName: string) => {
  const userDetails = useAppSelector(
    (state: LoginRootState) => state.authReducer.loginDetials
  );

  return useMemo(() => {
    return userDetails.menuAccess.some((menu) =>
      menu.functionalities.some(
        (func) => func.functionalityName === functionalityName && func.access
      )
    );
  }, [userDetails, functionalityName]);
};
